<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitStakeHolderData"> 
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-6">
              <label class="form-label">{{ $t('profile.stakeholder.name') }}</label><span class="text-danger"> *</span>
              <base-input
                  :invalid="$v.formData.name.$error"
                  v-model="formData.name"
                  ref="name"
                  type="text"
                  name="name"
                  tab-index="1"
                  @input="$v.formData.name.$touch()"
              />
              <div v-if="$v.formData.name.$error">
                  <span v-if="!$v.formData.name.required" class="text-danger">
                    {{ $tc('validation.required') }}
                  </span>
                  <span v-if="!$v.formData.name.minLength" class="text-danger">
                    {{ $tc('validation.name_min_length', $v.formData.name.$params.minLength.min, { count: $v.formData.name.$params.minLength.min }) }}
                  </span>
              </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.cnic') }}</label><span class="text-danger"> *</span>
                <base-input
                  :invalid="$v.formData.cnic.$error"
                  v-model="formData.cnic"
                  type="text"
                  tab-index="1"
                  
                  @input="$v.formData.cnic.$touch()"
                />
                <div v-if="$v.formData.cnic.$error">
                  <span v-if="!$v.formData.cnic.required" class="text-danger">
                    {{ $tc('validation.required') }}
                  </span>
                  <span v-if="!$v.formData.cnic.numeric" class="text-danger">
                    {{ $tc('validation.numbers_only') }}
                  </span>
                  <span v-if="!$v.formData.cnic.minLength" class="text-danger">
                    {{ $tc('validation.cnic_min_length', $v.formData.cnic.$params.minLength.min, { count: $v.formData.cnic.$params.minLength.min }) }}
                  </span>
                  <span v-if="!$v.formData.cnic.maxLength" class="text-danger">
                    {{ $tc('validation.cnic_max_length', $v.formData.cnic.$params.maxLength.max, { count: $v.formData.cnic.$params.maxLength.max }) }}
                  </span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.role') }}</label><span class="text-danger"> *</span>
                <base-select
                v-model="formData.role"
                :options="roleOptions"
                :class="{'error': $v.formData.role.$error }"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                :placeholder="$t('profile.stakeholder.role')"
                />
                <div v-if="$v.formData.role.$error">
                <span v-if="!$v.formData.role.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.executive_nonexecutive') }}</label><span class="text-danger"> *</span>
                <base-select
                v-model="formData.type"
                :options="typeOptions"
                :class="{'error': $v.formData.type.$error }"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                :placeholder="$t('profile.stakeholder.type')"
                />
                <div v-if="$v.formData.type.$error">
                <span v-if="!$v.formData.type.required" class="text-danger">{{ $tc('validation.required') }}</span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.email') }}</label>
                <base-input
                  :invalid="$v.formData.email.$error"
                  v-model.trim="formData.email"
                  type="text"
                  name="email"
                  tab-index="3"
                  @input="$v.formData.email.$touch()"
                />
                <div v-if="$v.formData.email.$error">
                  <span v-if="!$v.formData.email.email" class="text-danger">
                    {{ $tc('validation.email_incorrect') }}
                  </span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.address') }}</label>
                <base-input
                    v-model="formData.address"
                    type="text"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.phone_office') }}</label>
                <base-input
                  v-model.trim="formData.phone_office"
                  type="text"
                  name="phone"
                  tab-index="4"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.phone_res') }}</label>
                <base-input
                  v-model.trim="formData.phone_res"
                  type="text"
                  name="phone"
                  tab-index="4"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.phone_cell') }}</label>
                <base-input
                  v-model.trim="formData.phone_cell"
                  type="text"
                  name="phone"
                  tab-index="4"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.fax') }}</label>
                <base-input
                  v-model.trim="formData.fax"
                  type="text"
                  tab-index="4"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.national_tax_num') }}</label>
                <base-input
                  v-model.trim="formData.national_tax"
                  type="text"
                  tab-index="4"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.share_holding') }}</label>
                <base-input
                  v-model="formData.share_holding"
                  type="text"
                  tab-index="4"
                />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.amount') }}</label>
                 <div class="base-input">
                    <money
                        :class="{'invalid' : $v.formData.amount.$error}"
                        v-model="amount"
                        v-bind="defaultCurrencyForInput"
                        class="input-field"
                    />
                </div>
                <div v-if="$v.formData.amount.$error">
                  <span v-if="!$v.formData.amount.numeric" class="text-danger">{{ $tc('validation.numbers_only') }}</span>
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.per_share_holding') }}</label>
                <base-input
                  v-model="formData.per_share_holding"
                  type="text"
                  tab-index="4"
                />
            </div>  
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeStakeHolderModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, maxLength, email, url, numeric,minValue,maxValue } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isEdit: false,
        isLoading: false,
        formData: {
          id:null,
          name: null,
          address:null,
          email: null,
          cnic:null,
          role:null,
          type:null,
          fax:null,
          national_tax:null,
          share_holding:null,
          per_share_holding:null,
          amount:null,
          phone_office:null,
          phone_cell:null,
          phone_res:null
        },
        roleOptions: ['OWNER','PARTNER','DIRECTOR'],
        typeOptions:['EXECUTIVE','NON-EXECUTIVE'],
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
     ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    amount: {
      get: function () {
        return this.formData.amount / 100
      },
      set: function (newValue) {
        this.formData.amount = newValue * 100
      }
    } 
  },
  created(){
  },
 validations: {
      formData: {
        name: {
          required,
          minLength: minLength(3)
        },
        role: {
          required,
        },
        type: {
          required,
        },
        cnic: {
          required,
          numeric,
          minLength: minLength(13),
          maxLength: maxLength(13)
        },
        email: {
          email,
        },
        amount:{
            numeric,
            maxLength: maxLength(20)
        }
        
      },
 },
  async mounted () {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('stakeholder', [
      'addStakeholder',
      'updateStakeholder'
    ]),
    resetFormData () {  
      this.formData = {
         id:null,
          name: null,
          address:null,
          email: null,
          cnic:null,
          role:null,
          type:null,
          fax:null,
          national_tax:null,
          share_holding:null,
          per_share_holding:null,
          amount:null,
          phone_office:null,
          phone_cell:null,
          phone_res:null
      }
      this.$v.formData.$reset()
    },
    async submitStakeHolderData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      let  response;
      if (this.isEdit) {
        response = await this.updateStakeholder(this.formData)
        if (response.data.result==true) { 
          window.toastr['success'](this.$t('profile.stakeholder.updated_message'))
          this.closeStakeHolderModal()
          return true
        }
        window.toastr['error'](response.data.error)
      } else {
        response = await this.addStakeholder(this.formData)  
        if (response.data.result==true) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('profile.stakeholder.created_message'))
            this.closeStakeHolderModal()
            return true
        } 
          window.toastr['error'](response.data.error)
      }   
    },
    async setData () {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        cnic: this.modalData.cnic,
        role: this.modalData.role,
        type: this.modalData.type,
        address:  this.modalData.address,
        amount: this.modalData.amount,
        phone_office: this.modalData.phone_office,
        phone_res:  this.modalData.phone_res,
        phone_cell: this.modalData.phone_cell,
        email:  this.modalData.email,
        fax:  this.modalData.fax,
        national_tax: this.modalData.national_tax,
        share_holding:  this.modalData.share_holding,
        per_share_holding:  this.modalData.per_share_holding,
      }
    },
    closeStakeHolderModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
